import React from 'react'
import { isNilEmpty } from 'Utils'
import PropTypes from 'prop-types'

const IFRAME_BASE_URL = {
  Vimeo: 'https://player.vimeo.com/video/',
  Youtube: 'https://www.youtube.com/embed/',
  Matterport: 'https://my.matterport.com/show/?m=',
}

export const TEST_IDS = {
  MEDIA_FRAME: 'media-iframe',
}

const Medias = ({ title, medias }) => {
  if((isNilEmpty(medias))) return null
  return Object.values(medias).map(media => {
    const { media_type: mediaType } = media
    const baseUrl = IFRAME_BASE_URL[mediaType]
    if(!baseUrl) return null
    return (
      <iframe
        data-test-id={TEST_IDS.MEDIA_FRAME}
        title={`${title || ''} ${media.media_type}`}
        width="100%"
        height="480"
        src={baseUrl + media.media_id}
        frameBorder="0"
        allowFullScreen
        allow="vr"
        key={media.media_id}
      />
    )
  })
}
Medias.propTypes = {
  title: PropTypes.string,
  medias: PropTypes.oneOfType([
    PropTypes.shape({
      Matterport: PropTypes.shape({}),
      MPEmbed: PropTypes.shape({}),
    }),
    PropTypes.arrayOf(PropTypes.shape({})),
  ]).isRequired,
}

export default Medias
